import { render, staticRenderFns } from "./PatientBaseInfo.vue?vue&type=template&id=01a04ea2&scoped=true&"
import script from "./PatientBaseInfo.vue?vue&type=script&lang=js&"
export * from "./PatientBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./PatientBaseInfo.vue?vue&type=style&index=0&id=01a04ea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a04ea2",
  null
  
)

export default component.exports